import { render, staticRenderFns } from "./goods-management.vue?vue&type=template&id=2b0b4fae&scoped=true&"
import script from "./goods-management.vue?vue&type=script&lang=js&"
export * from "./goods-management.vue?vue&type=script&lang=js&"
import style0 from "./goods-management.vue?vue&type=style&index=0&id=2b0b4fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b4fae",
  null
  
)

export default component.exports